import type { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@headerhawk/ui";

interface BadgeTooltipProps {
  content: string;
  children: ReactNode;
}

export function BadgeTooltip({ content, children }: BadgeTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-default">{children}</span>
      </TooltipTrigger>
      <TooltipContent>{content}</TooltipContent>
    </Tooltip>
  );
}
